export const formatDAUValue = (value: number): string => {
    if (value === 0) {
        return "-";
    }
    return `${(value * 100).toFixed(2)} %`;
};
